import { useCallback, useEffect, useState } from 'react';
import { jsonAxios } from 'components/axios';
import MyPageTemplate from 'components/template/MyPageTemplate';
import Loading from 'components/common/Loading';
import First from 'components/as/list/First';
import { IAS, IDocumentSelect, ISearchInfo } from 'types/as';
import { ReactComponent as Down } from 'assets/mypage/asDown.svg'
import DocumentPop from 'components/common/modal/DocumentPop';
import AsDrawer from 'components/drawer/AsDrawer';
import Pagination from 'components/common/Pagination';

const ASList = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [asList, setAsList] = useState<IAS[]>([]);
    const [searchInfo, setSearchInfo] = useState<ISearchInfo>({
        page: 1,
    } as ISearchInfo)
    const [popOpen, setPopOpen] = useState<boolean>(false);
    const [documentSelect, setDocumentSelect] = useState<IDocumentSelect>({} as IDocumentSelect)
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [select, setSelect] = useState<number>(0);
    const [totalPage, setTotalPage] = useState<number>(0)

    const tHeader = [
        { label: "No.", flex: 0.5 },
        { label: "날짜", flex: 1.0 },
        { label: "카테고리", flex: 1.0 },
        { label: "제목", flex: 1.5 },
        { label: "내용", flex: 1.5 },
        { label: "첨부파일", flex: 1.0 },
    ];

    const init = useCallback(() => {
        setLoading(true)
        const params = new URLSearchParams(Object.entries(searchInfo)).toString();

        jsonAxios.get(`user/warehouse?${params}`).then(res => {
            console.log(res.data)
            if (res.data.code === 200) {
                setAsList(res.data.data)
                setTotalPage(res.data.totalPages || 0);
            }
        }).finally(() => {
            setTimeout(() => {
                setLoading(false)
            }, 400)
        })
    }, [searchInfo])

    useEffect(() => {
        init();
    }, [init])

    const toggleDrawer = () => {
        setIsOpen((p) => !p)
    }

    const titleStyle = () => {
        return `hidden tablet:block flex-[1.0] w-full bg-[#e5e5e5] py-1`
    }

    const tBodyStyle = () => {
        return `flex items-center justify-center py-2 text-center tablet:py-0 tablet:gap-2`
    }
    return (
        <MyPageTemplate background='bg-[#F8F8FA]'>
            <div className='flex flex-col gap-25 h-full min-h-dvh'>
                <div className="flex flex-col gap-6 pt-10 tablet:pt-4">
                    <First
                        searchInfo={searchInfo}
                        setSearchInfo={setSearchInfo}
                        init={() => { }}
                    />

                    <div className='flex flex-col gap-3 bg-white hover:shadow-lg p-10 mobile:p-6 tablet:px-4 rounded-xl w-full transition-all'>
                        {
                            loading ?
                                <div className='flex justify-center items-center w-full'>
                                    <Loading />
                                </div> :
                                <>
                                    <div className='tablet:hidden flex bg-[#F8F8FA] font-semibold text-sm 2xl:text-base'>
                                        {
                                            tHeader.map((item, idx) => (
                                                <div
                                                    key={idx}
                                                    className={`flex-[${item.flex}] flex items-center justify-center h-15`}
                                                >
                                                    {item.label}
                                                </div>
                                            ))
                                        }
                                    </div>

                                    {
                                        asList.length > 0 ?
                                            <div className='flex flex-col gap-3 min-h-[30vh]'>
                                                {
                                                    asList.map((item, idx) => (
                                                        <div
                                                            className={`relative flex text-sm border border-[#E1E1E8] transition-all rounded tablet:flex-col tablet:gap-1 xl:h-20 cursor-pointer hover:bg-[#EEF4FF]`}
                                                            key={idx}
                                                            onClick={() => {
                                                                setIsOpen(true)
                                                                setSelect(item.id)
                                                            }}
                                                        >
                                                            {
                                                                item.hasUnconfirmed &&
                                                                <div className='top-2 left-2 absolute bg-red rounded-full w-2 h-2 font-semibold text-white text-xs'></div>
                                                            }

                                                            <div className={`flex-[0.5] ${tBodyStyle()} tablet:order-1`}>
                                                                <span className={titleStyle()}>{tHeader[0].label}</span>
                                                                <span className='flex-1'>
                                                                    {10 * (searchInfo.page - 1) + idx + 1}
                                                                </span>
                                                            </div>
                                                            <div className={`flex-[1.0] ${tBodyStyle()} tablet:order-2`}>
                                                                <span className={titleStyle()}>{tHeader[1].label}</span>
                                                                <span className='flex-1'>
                                                                    {item.createAt}
                                                                </span>
                                                            </div>
                                                            <div className={`flex-[1.0] ${tBodyStyle()} tablet:order-2`}>
                                                                <span className={titleStyle()}>{tHeader[1].label}</span>
                                                                <span className='flex-1'>
                                                                    {item.categoryName ?? '-'}
                                                                </span>
                                                            </div>
                                                            <div className={`flex-[1.5] min-w-0 ${tBodyStyle()} tablet:order-3`}>
                                                                <p className='truncate'>
                                                                    {item.title}
                                                                </p>
                                                            </div>
                                                            <div className={`flex-[${tHeader[3].flex}] min-w-0 ${tBodyStyle()} tablet:order-3`}>
                                                                <span className={titleStyle()}>{tHeader[3].label}</span>
                                                                <p className='truncate'>
                                                                    {item.content}
                                                                </p>
                                                            </div>

                                                            <div className={`flex-[1.0] ${tBodyStyle()} tablet:order-5`}>
                                                                <span className={titleStyle()}>{tHeader[4].label}</span>
                                                                <span className='flex flex-1 justify-center items-center'>
                                                                    <Down
                                                                        fill={item.fileList.length > 0 ? '#196BFF' : '#9D9EB7'}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            if (item.fileList.length > 0) {
                                                                                setPopOpen(true)
                                                                                setDocumentSelect({
                                                                                    title: item.title,
                                                                                    content: item.content,
                                                                                    createAt: item.createAt,
                                                                                    fileList: item.fileList
                                                                                })
                                                                            }
                                                                        }}

                                                                    />
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            :
                                            <div className='flex justify-center items-center py-6 min-h-[30vh]'>
                                                데이터가 없습니다.
                                            </div>
                                    }
                                </>
                        }
                    </div>
                    <Pagination
                        totalPage={totalPage}
                        currentPage={searchInfo.page}
                        onClick={(idx) => {
                            setSearchInfo(p => ({
                                ...p,
                                page: (idx + 1)
                            }))
                        }}
                    />
                </div>
            </div>
            <DocumentPop
                isOpen={popOpen}
                setIsOpen={setPopOpen}
                documentSelect={documentSelect}
            />

            <AsDrawer
                isOpen={isOpen}
                toggleDrawer={toggleDrawer}
                id={select}
            />

        </MyPageTemplate>
    )
}

export default ASList